import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
export default {
  name: 'CoreCsvExportSearchVirtualDevices',
  mixins: [multiSearchMixin],
  props: {
    search: {
      type: Array,
      required: false,
      default: () => []
    },
    operator: {
      type: String,
      required: false,
      default: 'AND'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    copyMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  mounted() {
    this.searchItems = this.search;
  },
  methods: {}
};